import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { Datepicker, Form, Select, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import {
  dateToJalali,
  getStatus,
  serverErrorHandler,
} from '../../../Utils/Helpers';
import { AgeContext } from '../Context/AgeContext';

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError('عنوان الزامی است')
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی تواند بیشتر از 190 کاراکتر باشد'),
  start_age: Yup.string().required('شروع رده سنی الزامی است'),
  end_age: Yup.string().required('پایان رده سنی الزامی است'),
  status: Yup.number()
    .typeError('انتخاب وضعیت الزامی است')
    .required('انتخاب وضعیت الزامی است'),
});

const Edit = () => {
  const { id } = useParams();
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { get, put } = useApi();
  const { error, success } = useToast();
  const context = useContext(AgeContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      await getAge();
    };
    getData();
  }, [id]);

  const getAge = async () => {
    setLoading(true);
    await get(
      `/age/${id}`,
      (res) => {
        context.age = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await put(
      `/age/${id}`,
      values,
      (res) => {
        success(`رده سنی "${context?.age?.title}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        getAge();
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`رده سنی "${context?.age?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title={`ویرایش رده سنی ${context.age?.title} `}
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/age'
      />
      <Form
        initialValues={{
          title: context?.age?.title ?? '',
          start_age: dateToJalali(context?.age?.start_age),
          end_age: dateToJalali(context?.age?.end_age),
          status: context?.age?.status,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Datepicker
                title='شروع رده سنی'
                name='start_age'
                minDate={new Date('1830/01/01')}
                serverError={serverErrors.start_age}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='پایان رده سنی'
                name='end_age'
                minDate={new Date('1830/01/01')}
                serverError={serverErrors.end_age}
              />
            </div>
            <div className='col-12'>
              <Select
                title='وضعیت'
                name='status'
                optionLabel='label'
                optionValue='value'
                options={getStatus()}
                serverError={serverErrors.status}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Edit;
